import {Card} from 'react-bootstrap'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import CardTitle from '../../../common/styles/CardTitle'
import useBookRecommenders from './useBookRecommenders'
import BookRecommenderListRow from "./BookRecommenderListRow";
import BookRecommenderListRowLoading from "./BookRecommenderListRowLoading";
import BooksitoutIcon from "../../../config/BooksitoutIcon";
import CardBodyContainer from "../../../common/styles/CardBodyContainer";
import NoContent from "../../../common/NoContent";
import styled from "styled-components";

const BookRecommendersCard: React.FC<{purpose?: 'index' | 'others'}> = ({purpose}) => {
    let content = <Content/>

    if (purpose === 'index') {
        return (
            <Card>
                <CardBodyContainer>
                    {content}
                </CardBodyContainer>
            </Card>
        )
    }

    return (
        <Card>
            <CardBodyContentContainer height={600}>
                {content}
            </CardBodyContentContainer>
        </Card>
    )
}

const Content = () => {
    const [isLoading, recommenders] = useBookRecommenders(5)

    return (
        <>
            <CardTitle
                icon={<BooksitoutIcon.recommend/>}
                title='책 추천 받기'
                url='/community/book-recommendations'
            />

            {isLoading ? (
                <>
                    {[1, 2, 3, 4, 5].map((_) => (<BookRecommenderListRowLoading colorType={'card-card'}/>))}
                </>
            ) : recommenders.length === 0 ? (
                <NoContentCenter>
                    <NoContent message={'아직 책 추천이 없어요'}/>
                </NoContentCenter>
            ) : (
                recommenders.map((recommender) => <BookRecommenderListRow recommender={recommender}
                                                                          colorType={'card-card'}/>)
            )}
        </>
    )
}

const NoContentCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
`

export default BookRecommendersCard